import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import PageHeader from "../components/PageHeader";
import CoverGrid from "../components/CoverGrid";
import { PRODUCTS } from "../data/products";

export default function ManualiPage() {
  const { items, basePath } = PRODUCTS.manuali;
  return (
    <div className="px-5 sm:px-8 lg:px-12 py-16 sm:py-20 max-w-6xl mx-auto">
      <Link
        to="/prodotti/risorse"
        data-testid="manuali-back-link"
        className="inline-flex items-center gap-2 text-[11px] tracking-[0.28em] uppercase text-white/40 hover:text-white/80 transition mb-10"
      >
        <ChevronLeft className="w-3.5 h-3.5" />
        Torna a Risorse
      </Link>

      <PageHeader
        eyebrow="Risorse · Manuali"
        title="Manuali."
        description="Manuali di riferimento del progetto TIME. Copertine reali, contenuti in preparazione."
        testId="manuali-header"
      />

      <CoverGrid items={items} basePath={basePath} testId="manuali-grid" />
    </div>
  );
}
